export namespace Permissions {
	export class FetchAll {
		static readonly type = "[Permissions] Fetch all";
	}

	export class FetchUserPermissions {
		static readonly type = "[Permissions] Fetch User Permissions";
		constructor(public userId: number) {}
	}

	export class UpdateUserPermissions {
		static readonly type = "[Permissions] Update User Permissions";
		constructor(public userId: number, public permissions: any) {}
	}
}
